import {NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

export const DEAL_PAYROLL_GROUP_SETTINGS_HTTP_STATUS = {
  CONFLICT: 409,
  FORBIDDEN: 403
};

export const DEAL_PAYROLL_GROUP_SETTINGS_ERROR_KEY = {
  NONE: '',
  LOAD: 'DEAL_PAYROLL_SETTINGS_LOAD_ERROR',
  SAVE: 'DEAL_PAYROLL_SETTINGS_SAVE_ERROR',
  FORBIDDEN: 'DEAL_PAYROLL_SETTINGS_FORBIDDEN',
  STALE: 'DEAL_PAYROLL_SETTINGS_STALE'
};

export const DEAL_PAYROLL_GROUP_SETTINGS_FEEDBACK_KEY = {
  NONE: '',
  SAVED: 'DEAL_PAYROLL_SETTINGS_SAVED'
};

export const DEAL_PAYROLL_AREA_CATALOG_STATE_KEY = {
  NONE: '',
  UNAVAILABLE_STORED: 'DEAL_PAYROLL_AREA_CATALOG_UNAVAILABLE_STORED',
  UNAVAILABLE_EMPTY: 'DEAL_PAYROLL_AREA_CATALOG_UNAVAILABLE_EMPTY',
  AVAILABLE_EMPTY: 'DEAL_PAYROLL_AREA_CATALOG_EMPTY',
  REFRESHING: 'DEAL_PAYROLL_AREA_CATALOG_REFRESHING',
  RETRY_DIRTY: 'DEAL_PAYROLL_AREA_CATALOG_RETRY_DIRTY'
};

export const DEAL_PAYROLL_GROUP_SETTINGS_INITIAL_SEQUENCE = 0;
export const DEAL_PAYROLL_GROUP_SETTINGS_REMOVE_POSITION_COUNT = 1;
export const DEAL_PAYROLL_GROUP_SETTINGS_EMPTY_VALUE = '';
export const DEAL_PAYROLL_GROUP_SETTINGS_NEW_POSITION_PREFIX = 'new-';
export const DEAL_PAYROLL_GROUP_SETTINGS_TRACK_KEY_SEPARATOR = ':';
export const DEAL_PAYROLL_GROUP_SETTINGS_SAVED_RESULT = 'deal-payroll-group-settings-saved';

export const DEAL_PAYROLL_GROUP_SETTINGS_MODAL_OPTIONS: NgbModalOptions = {
  size: 'lg',
  backdrop: 'static',
  keyboard: false
};



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-group/deal-payroll-group-settings/deal-payroll-group-settings.constants.ts